import { Context } from '@/context/appContext';
import { pushNotificationMessage } from '@/services/NotifactionsService';
import { useCallback, useContext } from 'react';

// TODO: Custom implementation here. No message stacking, fragile positioning. Use mui snackbar?
export function useNotifications() {
  const { dispatch } = useContext(Context);

  const notify = useCallback(
    (message: string, type?: 'info' | 'error' | 'success') => pushNotificationMessage(dispatch, message, type, 5000),
    [dispatch],
  );

  const notifyError = useCallback((message: string) => notify(message, 'error'), [notify]);
  const notifyInfo = useCallback((message: string) => notify(message, 'info'), [notify]);
  const notifySuccess = useCallback((message: string) => notify(message, 'success'), [notify]);

  return { notify, notifyError, notifyInfo, notifySuccess };
}
